import { Link } from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { useCrumbs } from "@/components/layout/CrumbsContext";
import { SolutionsTable } from "@/components/plan-audit/SolutionsTable";
import { Button } from "@/components/ui/button";

/**
 * Solutions — the app's home. A plain list of every solution with its first-pass
 * score, latest score and the movement between them.
 *
 * "New audit" is a page action, not a table action: it starts a run on any
 * solution (or a new one), so it does not belong to the list's own toolbar.
 */
export function SolutionsPage() {
  useCrumbs([{ label: "All solutions" }]);
  return (
    <>
      <div className="pa-page-head">
        <div>
          <h1>Solutions</h1>
          <p>
            One solution per engagement. Each keeps every version of its plan, and every audit run
            against those versions.
          </p>
        </div>
        <div className="pa-page-actions">
          <Button asChild>
            <Link to="/new-audit">
              <Plus aria-hidden="true" />
              New audit
            </Link>
          </Button>
        </div>
      </div>
      <SolutionsTable />
    </>
  );
}
